<template>
  <vue-draggable-resizable
    drag-handle=".headerClass"
    class="wrap container araeLocationClass onePictureDialog dy3dDialog"
    :w="dragW"
    :h="dragH"
    :onResize='onResize'
    v-if="showMode">
    <div class="headerClass">
      <div class="headerTitle">
        <span>区域定位</span>
      </div>

      <div class="boxClose">
        <img
          :src="require('@/assets/images/poscloseIcon.png')"
          style="cursor: pointer"
          @click="close()"/>
      </div>
    </div>
    <img class="splitLine" :src="require('@/assets/images/splitlineIcon.png')"/>
    <div class="curPosition">
      <div class="content">
        <img :src="require('@/assets/images/curPositionIcon.png')" alt="" />
        <span class="cityClass">{{ firstAreaName }}</span>
        <span class="cityClass" v-if="secondAreaName">{{ "  " + secondAreaName }}</span>
        <span class="cityClass" v-if="thirdAreaName">{{ "  " + thirdAreaName }}</span>
        <span class="cityClass" v-if="fourthAreaName">{{ "  " + fourthAreaName }}</span>
        <span class="spanClass">（当前定位区域）</span>
      </div>
      <a-divider></a-divider>
    </div>
    <!-- 第一级区域选择 -->
    <div class="firstAreaSelect citySelect" v-if="firstLevelArea.length > 0">
      <div class="oneLine">
        <img :src="require('@/assets/images/positionIcon.png')" alt="" />
        <span class="cityClass">{{firstLevelArea[0].level}}选择</span>
      </div>
      <div class="twoLine">
        <a-radio-group v-model="firstAreaName">
          <a-radio v-for="(item, index) of firstLevelArea" :key="index" :value="item.mc" @click="areaClick(1,item)">
            {{item.mc}}
          </a-radio>
        </a-radio-group>
        <!-- <span
          v-for="(item, index) of firstLevelArea"
          :key="index"
          @click="areaClick(1, item, index)"
          :class="firstAreaName == item.mc ? 'spanActive' : ''"
          >{{ item.mc }}</span> -->
      </div>
      <a-divider v-if="secondLevelArea.length > 0"></a-divider>
    </div>
    <!-- 第二级区域选择 -->
    <div class="secondAreaSelect citySelect" v-if="secondLevelArea.length > 0">
      <div class="oneLine">
        <img :src="require('@/assets/images/positionIcon.png')" alt="" />
        <span class="cityClass">{{secondLevelArea[0].level}}选择</span>
      </div>
      <div class="twoLine">
        <a-radio-group v-model="secondAreaName">
          <a-radio v-for="(item, index) of secondLevelArea" :key="index" :value="item.mc" @click="event => areaClick(2,item)">
            {{item.mc}}
          </a-radio>
        </a-radio-group>
        <!-- <span
          v-for="(item, index) of secondLevelArea"
          :key="index"
          @click="areaClick(2, item, index)"
          :class="secondAreaName == item.mc ? 'spanActive' : ''"
          >{{ item.mc }}</span> -->
      </div>
      <a-divider v-if="thirdLevelArea.length > 0"></a-divider>
    </div>
    <!-- 第三级区域选择 -->
    <div class="thirdAreaSelect citySelect" v-if="thirdLevelArea.length > 0">
      <div class="oneLine">
        <img :src="require('@/assets/images/positionIcon.png')" alt="" />
        <span class="cityClass">{{thirdLevelArea[0].level}}选择</span>
      </div>
      <div class="twoLine">
        <a-radio-group v-model="thirdAreaName">
        <!-- <a-radio-group v-model="thirdAreaName" @change="event => areaClick(3,event.target.value)"> -->
          <a-radio v-for="(item, index) of thirdLevelArea" :key="index" :value="item.mc" @click="event => areaClick(3,item)">
            {{item.mc}}
          </a-radio>
        </a-radio-group>
        <!-- <span
          v-for="(item, index) of thirdLevelArea"
          :key="index"
          @click="areaClick(3, item, index)"
          :class="thirdAreaName == item.mc ? 'spanActive' : ''"
          >{{ item.mc }}</span> -->
      </div>
      <a-divider v-if="fourthLevelArea.length > 0"></a-divider>
    </div>
    <!-- 第四级区域选择 -->
    <div class="fourthAreaSelect citySelect" v-if="fourthLevelArea.length > 0">
      <div class="oneLine">
        <img :src="require('@/assets/images/positionIcon.png')" alt="" />
        <span class="cityClass">{{fourthLevelArea[0].level}}选择</span>
      </div>
      <div class="twoLine">
        <a-radio-group @change="event => areaClick(4,event.target.value)">
          <a-radio v-for="(item, index) of fourthLevelArea" :key="index" :value="item.mc">
            {{item.mc}}
          </a-radio>
        </a-radio-group>
        <!-- <span
          v-for="(item, index) of fourthLevelArea"
          :key="index"
          @click="areaClick(4, item, index)"
          :class="fourthAreaName == item.mc ? 'spanActive' : ''"
          >{{ item.mc }}</span> -->
      </div>
    </div>
  </vue-draggable-resizable>
</template>
  
<script>
  import "proj4leaflet";
  export default {
    name: "areaLocation",
    props: {
      /** 
       * 用户有权限的区域数据
       * @example [{dm:'320600',level:'市',mc:'南通市'}]
       */
      qyData: {
        type: Array,
        default: () => []
      },
      /** 
       * 县级行政区，包含
       * @param {string} xjxzq.geoserverUrl   地址
       * @param {string} xjxzq.layer   图层名
       */
      xjxzq: {
        type: Object,
        default: () => {}
      },
      /** 
       * 市级行政区，包含
       * @param {string} sjxzq.geoserverUrl   地址
       * @param {string} sjxzq.layer   图层名
       * @example {geoserverUrl:'http://192.168.1.16:9090/geoserver/ntzcqc/ows', layer:'ntzcqc:f_sjxzq'}
       */
      sjxzq: {
        type: Object,
        default: () => {}
      }
    },
    data() {
      return {
        dragW: 500,
        dragH: 'auto',
        showMode: false,
        pointEntity: null,
        cityActive: -1,
        areaActive: -1,
        center: {
          lat: 31.814176,
          lng: 117.225362,
          alt: 5105.3,
          heading: 359.2,
          pitch: -83.1,
        },
        cityName: null,
        areaName: null,
        cityArry: [],
        areaArry: [],
        pointArry: [],
        escCount: 0,
        clickAreas: [], // 点击的省市县乡镇的数据

        firstAreaName:'',  // 点击的第一级区域名称
        secondAreaName:'',  // 点击的第二级区域名称
        thirdAreaName:'',  // 点击的第三级区域名称
        fourthAreaName:'',  // 点击的第四级区域名称
        firstLevelArea:[], // 第一级区域数据
        secondLevelArea:[], // 第二级区域数据
        thirdLevelArea:[], // 第三级区域数据
        fourthLevelArea:[], // 第四级区域数据
      };
    },
    mounted() {
      window.addEventListener("keydown", this.handleKeydown);
    },
    beforeUnmount() {
      window.removeEventListener("keydown", this.handleKeydown);
    },
    methods: {
    // 弹框缩放中事件
      onResize(handle, x, y, width, height){
        console.log('onResize',handle,x,width,y,height);
        if(width < 300){
          return false
        }
      },
      //监听键盘事件
      handleKeydown(event) {
        if (event.keyCode === 27) {
          this.escCount++;
          this.hideGraphic();
        }
      },
      // 关闭弹框
      close() {
        this.escCount = 0;
        this.showMode = false;
        this.hideGraphic();
      },
      hideGraphic() {
        if (this.sjxzqLayer) {
          this.sjxzqLayer.clear();
          this.map && this.map.removeLayer(this.sjxzqLayer);
          this.sjxzqLayer = null;
        }
        this.cityName = null;
        this.areaName = null;
        this.cityActive = -1;
        this.areaActive = -1;
      },
      // 初始化弹框
      setMap(map) {
        this.map = map;
        this.showMode = true;
        this.firstAreaName = ''  // 点击的第一级区域名称
        this.secondAreaName = ''  // 点击的第二级区域名称
        this.thirdAreaName = ''  // 点击的第三级区域名称
        this.fourthAreaName = ''  // 点击的第四级区域名称
        this.secondLevelArea = [] // 第二级区域数据
        this.thirdLevelArea = [] // 第三级区域数据
        this.fourthLevelArea = [] // 第四级区域数据

        let province = this.qyData.filter(e => e.level == '省')
        let city = this.qyData.filter(e => e.level == '市')
        let county = this.qyData.filter(e => e.level == '县')
        let town = this.qyData.filter(e => e.level == '乡镇')
        if(province.length > 0){
          this.firstLevelArea = province
        }else if(province.length == 0 && city.length > 0){
          this.firstLevelArea = city
        }else if(province.length == 0 && city.length == 0 && county.length > 0){
          this.firstLevelArea = county
        }else if(province.length == 0 && city.length == 0 && county.length == 0&& town.length > 0){
          this.firstLevelArea = town
        }else{
          this.firstLevelArea = []
        }
        // this.cityArry = [];
        // this.areaArry = [];
        // for (var item of this.qyData) {
        //   if (item.level == "市") {
        //     this.cityArry.push(item);
        //   }
        // }
      },
      // 定位
      flyToPosition(code, level) {
        if (this.sjxzqLayer) {
          this.map.removeLayer(this.sjxzqLayer);
        }
        this.sjxzqLayer = new mars3d.layer.GeoJsonLayer({
          symbol: {
            type: "polygonP",
            styleOptions: {
              color: "#3388ff",
              opacity: 0.3,
              outline: true,
              outlineWidth: 3,
              outlineColor: "#3388ff",
            },
          },
          flyTo: true,
        });
        this.map.addLayer(this.sjxzqLayer);
        const that = this;
        if (level == '县') {
          this.sjxzqQueryLayer = new mars3d.query.QueryGeoServer({
            url: this.xjxzq.geoserverUrl,
            layer: this.xjxzq.layer,
            // url: "http://192.168.1.16:9090/geoserver/ntzcqc/ows",
            // layer: "ntzcqc:f_xjxzq",
          });
        } else if(level == '市') {
          this.sjxzqQueryLayer = new mars3d.query.QueryGeoServer({
            url: this.sjxzq.geoserverUrl,
            layer: this.sjxzq.layer,
            // url: "http://192.168.1.16:9090/geoserver/ntzcqc/ows",
            // layer: "ntzcqc:f_sjxzq",
          });
        } else {
          this.$message.warning(`暂无${level}级数据`);
          return
        }
        this.sjxzqQueryLayer.query({
          column: "xzqdm",
          text: `${code}`,
          success: (result) => {
            console.log(result);
            if (result.count === 0) {
              that.$message.warning("未查询到相关记录");
              return;
            } else {
              that.sjxzqLayer.load({ data: result.geojson });
            }
          },
        });
      },
      // 选择城市
      areaClick(order,item,index){
        console.log('选择城市',order,item);
        this.escCount = 0;
        // 区域所有级别
        let allLevels = ['first','second','third','fourth']
        allLevels.map((level,i) => {
          // i是下标，传进来的order是1 2 3 4（下标+1），为了下面写逻辑清晰点
          let idx = i + 1  
          if(idx == order){
            this[`${level}AreaName`] = item.mc
          }else if(idx == order + 1){
            // 选择了第order级的数据，它的下一级数据要更新
            this[`${level}AreaName`] = ''
            if(item.level == '省'){
              this[`${level}LevelArea`] = this.qyData.filter(e => e.level == '市')
            }else if(item.level == '市'){
              this[`${level}LevelArea`] = this.qyData.filter(e => e.level == '县' && e.dm.substring(0,4) == item.dm.substring(0,4))
            }else if(item.level == '县'){
              this[`${level}LevelArea`] = this.qyData.filter(e => e.level == '乡镇' && e.dm.substring(0,6) == item.dm.substring(0,6))
            }
          }else if(idx > order + 1){
            // 选择了第order级的数据，它的下一级数据的后面几级要清空
            this[`${level}AreaName`] = ''
            this[`${level}LevelArea`] = []
          }
        })
        this.flyToPosition(item.dm, item.level);
        // for (var menu of this.qyData) {
        //   if (item.dm.slice(0, 4) == menu.dm.slice(0, 4) && item.dm != menu.dm) {
        //     this.areaArry.push(menu);
        //   }
        // }
      },
    },
  };
</script>
  
<style lang="less" scoped>
  /**infoview浮动面板*/
  .araeLocationClass {
    position: absolute;
    width: 500px;
    height: auto !important;
    border-radius: 4px;
    color: #ffffff;
    box-shadow: 0 3px 14px rgba(128, 128, 128, 0.5);
    backdrop-filter: blur(15px);
    z-index: 10000 !important;
    padding: 0 8px 20px;
    min-height: 137px;
    .headerClass {
      position: relative;
      height: 30px;
      cursor: move;
      // .headerTitle {
      //   position: absolute;
      //   top: -5px;
      //   left: 8px;
      // }
      // .boxClose {
      //   position: absolute;
      //   top: 4px;
      //   right: 0;
      // }
    }
    .splitLine {
      width: 100%;
      height: 2px;
    }

    .curentCity {
      width: 100%;
      padding-left: 6px;
      .oneLine {
        display: flex;
        width: 100%;
        align-items: center;

        img {
          width: 20px;
          margin-left: 5px;
        }
        .cityClass {
          margin-left: 10px;
          font-size: 16px;
          color: #fff;
        }
        .spanClass {
          margin-bottom: 2px;
          font-size: 12px;
          color: rgba(255, 255, 255, 0.5);
        }
      }
      .twoLine {
        width: 99%;
        display: flex;
        flex-wrap: wrap;
        margin-top: 2%;
        // background: rgba(255, 255, 255, 0.2);
        padding-left: 10px;
        span {
          font-size: 14px;
          color: #a9a9a9;
          margin-left: 15px;
          cursor: pointer;
          margin-top: 5px;
          margin-bottom: 5px;
          padding: 2px;
        }
        .spanActive {
          font-size: 14px;
          color: #fff;
          margin-left: 15px;
          cursor: pointer;
          margin-top: 5px;
          padding: 2px 6px;
          border-radius: 2px;
        }
      }
      /deep/ .ant-divider {
        background: rgba(255, 255, 255, 0.2);
      }
    }
    .curPosition {
      display: flex;
      flex-direction: column;
      padding: 0 6px;
      .content {
        display: flex;
        align-items: center;
        img {
          width: 20px;
          margin-left: 5px;
        }
        .cityClass {
          font-size: 16px;
          margin-left: 10px;
        }
        .spanClass {
          color: rgba(255, 255, 255, 0.5);
        }
      }
      .ant-divider {
        margin: 10px 0;
      }
    }
    .citySelect {
      width: 100%;
      padding: 0 6px;
      .oneLine {
        display: flex;
        width: 100%;
        align-items: center;
        img {
          width: 20px;
          margin-left: 5px;
        }
        .cityClass {
          margin-left: 10px;
          font-size: 16px;
          color: #fff;
        }
      }
      .twoLine {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        margin-top: 2%;
        // background: rgba(255, 255, 255, 0.2);
        padding-left: 10px;
        span {
          font-size: 14px;
          color: #a9a9a9;
          margin-left: 15px;
          cursor: pointer;
          margin-top: 5px;
          margin-bottom: 5px;
          padding: 2px;
        }
        .spanActive {
          font-size: 14px;
          color: #fff;
          margin-left: 15px;
          cursor: pointer;
          margin-top: 5px;
          padding: 2px 6px;
          border-radius: 2px;
        }
      }
    }
  }
  .infoview-left {
    right: auto;
    left: 10px;
  }

  .araeLocationClass input,
  .araeLocationClass select,
  .araeLocationClass textarea {
    color: #ffffff;
    background-color: rgba(32, 160, 255, 0.2);
    border: 1px solid #e4eaec;
    font-size: 14px;
  }

  /deep/ .ant-divider-horizontal {
    margin: 15px 0;
    width: 100%;
  }
</style>
  